// Fetches Insights (blog) content. Backed by Firestore's `posts` collection
// in production; falls back to local seed data (src/data/blogPosts.js) so
// the Insights and Article pages render out of the box.
import { collection, getDocs, doc, getDoc, query, orderBy } from 'firebase/firestore';
import { db } from './firebase.js';
import { blogPosts } from '../data/blogPosts.js';

export async function fetchAllPosts() {
  try {
    const q = query(collection(db, 'posts'), orderBy('publishedAt', 'desc'));
    const snap = await getDocs(q);
    if (snap.empty) return blogPosts;
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  } catch {
    // Firestore not configured yet — use local seed content.
    return blogPosts;
  }
}

export async function fetchPostBySlug(slug) {
  try {
    const ref = doc(db, 'posts', slug);
    const snap = await getDoc(ref);
    if (snap.exists()) return { id: snap.id, ...snap.data() };
  } catch {
    // fall through to seed data
  }
  return blogPosts.find((p) => p.slug === slug) ?? null;
}
